import React from 'react';
export default function ({name, className, b}) {
  return <i className={`fa${b ? 'b' : 's'} fa-${name} ${className}`} />;
}
